<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <date-picker
                    :format="changeFormat"
                    :lang="lang"
                    confirm
                    placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                    range
                    type="date"
                    v-model="search.date">
                </date-picker>
                &nbsp;
                <multiselect
                    :customLabel="customLabel"
                    :options="items"
                    :show-labels="false"
                    class="form-control border-0"
                    placeholder="ประเภทใบภาษี"
                    track-by="value"
                    v-model="search.type">
                </multiselect>
                &nbsp;
                <input class="form-control"
                       placeholder="ค้นหาชื่อ/เลขผู้เสียภาษี"
                       type="text"
                       v-model="search.tax"/>
                &nbsp;
                <button @click="getData(1)"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    ค้นหา
                </button>
                &nbsp;
                <button :disabled="this.checkbox_id.length == 0"
                        @click="multiPrint()"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    <icon name="print"></icon>
                    พิมพ์หลายใบ
                </button>
                &nbsp;
                <button @click="toExcel()"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    <icon name="print"></icon>
                    รายงาน Excel
                </button>
                &nbsp;
                <button @click="create()"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    <icon name="plus"></icon>
                    สร้างใบภาษี
                </button>
                &nbsp;
            </div>
            <br/>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th></th>
                    <th>ประเภท</th>
                    <th>เลขประจำตัวผู้เสียภาษีอากร</th>
                    <th>วันที่ภาษี ที่จ่าย</th>
                    <th>จำนวน</th>
                    <th>ชื่อ</th>
                    <th>ผู้บันทึก</th>
                    <th>วันที่อัปเดต</th>
                    <th>PDF</th>
<!--                    <th>Excel</th>-->
                    <th>ดูข้อมูล</th>
                    <th>หมายเหตุ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="x in taxCustomerList">
                    <td>
                        <input :value="x[0].order_main" type="checkbox"
                               v-model="checkbox_id"/>
                    </td>
                    <td>{{x[0].type_main==3?'ภ.ง.ด. 3':'ภ.ง.ด. 53'}}</td>
                    <td>{{x[0].customer.tax_number}}</td>
                    <td>{{x[0].created_at}}</td>
                    <td>{{ totalTax(x) | currency }}</td>
                    <td>{{x[0].customer.name}}</td>
                    <td>{{x[0].user.name}}</td>
                    <td>{{x[0].updated_at}}</td>
                    <td>
                        <button @click="printTaxCustomerById(x[0].order_main,x[0].customer_id,x[0].order,x[0].created_at,'pdf')"
                                class="btn btn-primary"
                                type="button">
                        <icon name="print"></icon>
                        </button>
                    </td>
<!--                    <td>-->
<!--                        <button @click="printTaxCustomerById(x[0].order_main,'excel')"-->
<!--                                class="btn btn-primary"-->
<!--                                type="button">-->
<!--                        <icon name="print"></icon>-->
<!--                        </button>-->
<!--                    </td>-->
                    <td>
                        <button @click="showTaxCustomerById(x[0].order_main,x[0].customer_id,x[0].order,x[0].created_at)"
                                class="btn btn-primary"
                                type="button">
                        <icon name="pencil-alt"></icon>
                        </button>
                    </td>
                    <td>หมายเหตุ</td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="Paginate"
                        @paginate="getData(Paginate.current_page)"
        >
        </vue-pagination>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import {domain} from "@/util/Constants";
import moment from "moment";
import DatePicker from "vue2-datepicker";

export default {
        name: "CreditNoteList",
        components :{
            VuePagination,
            Loading,
            Multiselect,
            DatePicker
        },
        data(){
          return{
              status_loading : 1,
              msg : '',
              checkbox_id : [],
              search : {
                  tax : '',
                  date : [],
                  type : ''
              },
              items: [
                  { value: '', name: 'ทั้งหมด' },
                  { value: '3', name: 'ภ.ง.ด. 3' },
                  { value: '53', name: 'ภ.ง.ด. 53' },
              ],
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      return date ? moment(date).format('DD/MM/' + year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
              onload : true
          }
        },
        computed:{
            ...mapState({
                taxCustomerList :state=>{
                    return state.TaxInvoice.tax_customer_list
                },
                Paginate :state=>{
                    return state.TaxInvoice.pagination
                },
            })
        },
        created() {
            this.getData(1)
        },
        methods:{
            // this.status_loading = 3;
            // this.msg = 'ออกเอกสารไม่สำเร็จ';
            customLabel(option) {
                return `${option.name}`
            },
            create(){
                this.$router.push('/accounting/tax-customer-form/null')
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            multiPrint(){
                let id = '';

                this.checkbox_id.forEach((x,i)=>{
                    id+=i!=this.checkbox_id.length-1?x+',':x;
                })

                let url = domain + '/tax_customer/'+id;

                window.open(url,'_blank')
            },
            getData(page){
                this.status_loading = 1;
                this.msg = 'กำลังโหลด';
                if (!this.onload) this.showLoadingModal();
                let date_start = this.search.date.length>0?moment(this.search.date[0]).format("YYYY-MM-DD"):'';
                let date_end = this.search.date.length>0?moment(this.search.date[1]).format("YYYY-MM-DD"):'';
                let data = {
                    page : page,
                    date_start : date_start,
                    date_end : date_end,
                    search : this.search
                }
                this.$store.dispatch("TaxInvoice/getTaxCustomer",data).then(()=>{
                    if (!this.onload){
                        this.hideLoadingModal()
                    }
                    this.onload = false;
                })
            },
            total(arr) {
                return arr.reduce((acc, item) => acc + (item.amount?parseFloat(item.amount):0), 0)
            },
            totalTax(arr) {
                return arr.reduce((acc, item) => acc + (item.amount?parseFloat(item.amount)*(item.type/100):0), 0)
            },
            toExcel(){
                let date_start = this.search.date.length>0?moment(this.search.date[0]).format("YYYY-MM-DD"):'';
                let date_end = this.search.date.length>0?moment(this.search.date[1]).format("YYYY-MM-DD"):'';
                let data = {
                    date_start : date_start,
                    date_end : date_end,
                    search : this.search
                }

                let url = domain + `/tax_customer_excel?date_start=${data.date_start}&date_end=${data.date_end}&type=${data.search.type?data.search.type.value:''}&tax=${data.search.tax}`;

                window.open(url,'_blank')
            },
            printTaxCustomerById(id,customer_id,order,time,type) {
                let url = domain + '/tax_customer/'+id+'?type='+type+'&customer_id='+customer_id+'&order='+order+'&time='+time;

                window.open(url,'_blank')
            },
            showTaxCustomerById(id,customer_id,order,time) {
                console.log(id,customer_id,order,time)
                this.$router.push('/accounting/tax-customer-form/'+id+'?customer_id='+customer_id+'&order='+order+'&time='+time)
            }
        },
    }
</script>

<style scoped>
    .select{
        border:0
    }
</style>
